// src/components/TopNavbar.jsx
import { useEffect, useState } from 'react';
import {
  Group, Text, Menu, Avatar, UnstyledButton, Burger, 
  ActionIcon, Skeleton, Indicator, Box, Divider
} from '@mantine/core';
import {
  IconLogout, IconUser, IconArrowLeft, IconBell, 
  IconChevronDown, IconSettings
} from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api/axiosConfig';
import logo from '../img/Logo.png';

export default function TopNavbar({ opened, toggle, title = "SMS Grup", highlight = "" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState({ full_name: '', role: '' });
  const [loading, setLoading] = useState(true);

  const showBackButton = location.pathname !== '/';

  useEffect(() => { 
    const fetchCurrentUser = async () => {
      try {
        const response = await api.get('/dashboard/users/me');
        setUser({
          full_name: response.data.full_name || response.data.username,
          role: response.data.role === 'admin' ? 'Yönetici' : 'Personel'
        });
      } catch (error) {
        setUser({ full_name: 'Misafir', role: 'Bilinmiyor' });
      } finally {
        setLoading(false);
      }
    };
    fetchCurrentUser();
  }, []);

  const handleLogout = () => {
    localStorage.clear(); // Tüm verileri temizlemek daha güvenlidir
    navigate('/login');
  };

  const getInitials = (name) => {
    if (!name || name === 'Misafir') return 'M';
    return name.split(' ').map((n) => n[0]).join('').toUpperCase().substring(0, 2);
  };

  return (
    <> {/* Fragment ekledik: Modal'ın dışarıda olması için */}
      <Box
        px="lg"
        h="72px"
        style={{
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid var(--mantine-color-gray-2)',
          backgroundColor: 'rgba(255,255,255,0.85)',
          position: 'relative',
          zIndex: 100
        }}
      >
        <Group h="100%" justify="space-between" align="center" wrap="nowrap">
          {/* SOL BÖLÜM */}
          <Group gap="md" wrap="nowrap">
            {toggle && (
              <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
            )}

            {showBackButton && (
              <ActionIcon variant="subtle" size="lg" radius="xl" onClick={() => navigate('/')}>
                <IconArrowLeft size={20} />
              </ActionIcon>
            )}

            <Group gap={10} align="center" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              <img src={logo} alt="SMS Grup" width={40} height={40} />
              <div>
                <Text fw={800} size="lg" style={{ lineHeight: 1.1 }}>SMS Grup</Text>
                <Text size="xs" tt="uppercase" fw={700} style={{ letterSpacing: "1px", color: "#228be6" }}>
                  Personel Portalı
                </Text>
              </div>
            </Group>
          </Group>

          {/* SAĞ BÖLÜM */}
          <Group gap="md" wrap="nowrap">
            <Indicator size={8} offset={6} color="red" withBorder processing>
              <ActionIcon variant="light" size="lg" radius="xl">
                <IconBell size={20} stroke={1.6} />
              </ActionIcon>
            </Indicator>

            <Divider orientation="vertical" />

            <Menu shadow="md" width={240} position="bottom-end" radius="md">
              <Menu.Target>
                <UnstyledButton style={(theme) => ({ padding: '8px 12px', borderRadius: theme.radius.md })}>
                  <Group gap="sm" wrap="nowrap">
                    <Avatar size={40} radius="xl" variant="gradient" gradient={{ from: 'blue', to: 'cyan', deg: 135 }} fw={700}>
                      {loading ? <Skeleton circle height={40} /> : getInitials(user.full_name)}
                    </Avatar>
                    <Box visibleFrom="sm">
                      {loading ? (
                        <>
                          <Skeleton height={14} width={100} radius="xl" />
                          <Skeleton height={10} mt={6} width={70} radius="xl" />
                        </>
                      ) : (
                        <>
                          <Text size="sm" fw={600}>{user.full_name}</Text>
                          <Text size="xs" c="dimmed" fw={500}>{user.role}</Text>
                        </>
                      )}
                    </Box>
                    {!loading && <IconChevronDown size={16} />}
                  </Group>
                </UnstyledButton>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Hesap Yönetimi</Menu.Label>
                <Menu.Item leftSection={<IconUser size={16} />} onClick={() => navigate('/profile')}>Profil</Menu.Item>
                
                <Menu.Item leftSection={<IconSettings size={16} />}>Ayarlar</Menu.Item>
                <Menu.Divider />
                <Menu.Item color="red" leftSection={<IconLogout size={16} />} onClick={handleLogout}>
                  Çıkış Yap
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Group>
        </Group>
      </Box>
    </>
  );
}